module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-copyright element-without-heading",
    attrs: {
      "id": "copyright"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "copyright-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("HELLTOWN © 2017 Tina Glasneck")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Cover created by Taurus Colosseum")])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-medium inline-image-flow-left inline-image-flow-within-text inline-image-aspect-tall inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/depositphotos_255591240_s-2019.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter copyright-content"
  }, [_vm._v("Copyright notice: All rights reserved under the International and Pan-American Copyright Conventions. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("This is a work of fiction. Names, places, characters and incidents are either the product of the author’s imagination or are used fictitiously, and any resemblance to any actual persons, living or dead, organizations, events or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_c('sub', [_vm._v("Edition: 21Sept2021-01c")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 66
// module chunks = 0